import { render, staticRenderFns } from "./RegisterModel.vue?vue&type=template&id=172e7b0b&scoped=true&"
import script from "./RegisterModel.vue?vue&type=script&lang=ts&"
export * from "./RegisterModel.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterModel.vue?vue&type=style&index=0&id=172e7b0b&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172e7b0b",
  null
  
)

export default component.exports